"use client";

import { cn } from "@/lib/utils";

export const CHART_RANGES = [
  { label: "1J", years: 1 },
  { label: "3J", years: 3 },
  { label: "5J", years: 5 },
  { label: "10J", years: 10 },
  { label: "Max", years: null },
] as const;

export type ChartRangeLabel = (typeof CHART_RANGES)[number]["label"];

export function RangeSelector({
  value,
  onChange,
}: {
  value: ChartRangeLabel;
  onChange: (label: ChartRangeLabel) => void;
}) {
  return (
    <div className="flex shrink-0 gap-1 rounded-full bg-muted p-1">
      {CHART_RANGES.map((r) => (
        <button
          key={r.label}
          type="button"
          onClick={() => onChange(r.label)}
          className={cn(
            "rounded-full px-3 py-1 text-xs font-medium transition-colors",
            value === r.label
              ? "bg-card text-ink shadow-sm"
              : "text-muted-foreground hover:text-ink",
          )}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
